export default {
  props: ['presentVipSelected', 'size', 'config'],
  methods: {
    presentVipClick() {
      this.$emit('presentVipClick')
    },
  },
}
